module.exports = __webpack_public_path__ + "media/Components/fonts/PlayfairDisplayitalic-11107f9c4a59cce6d47da1b446fa0c9a.ttf";